/*
 * The design module's messages (editor, player, element labels). `libs/i18n/locales/sl.ts`
 * spreads this under the key `design`, so they are `t('design.…')`; `en.ts` here is
 * `satisfies DesignMessages`.
 */
const sl = {
    placeholder: 'Urejevalnik',

    types: {
        text:    'Besedilo',
        image:   'Slika',
        video:   'Video',
        weather: 'Vreme',
        clock:   'Ura',
        qr:      'QR koda',
        menu:       'Meni',
        happy_hour: 'Happy hour',
    },
    weights: {
        regular:  'Običajno',
        medium:   'Srednje',
        semibold: 'Polkrepko',
        bold:     'Krepko',
    },
    fit: {
        cover:   'Zapolni',
        contain: 'Prilagodi',
    },
    align: {
        left:   'Levo',
        center: 'Sredina',
        right:  'Desno',
    },
    /* Drawn ON a design (the plate of a logo that is not there yet) — the player has them too. */
    role: {
        brand_logo: 'Logotip znamke',
        guest_logo: 'Logotip gosta',
    },

    editor: {
        title:            'Urejevalnik zaslona',
        crumb_templates:  'Predstavitve',
        crumb_editor:     'Urejevalnik',
        undo:             'Razveljavi (⌘Z)',
        redo:             'Uveljavi (⇧⌘Z)',
        preview:          'Predogled',
        publish:          'Objavi',
        published:        'Objavljeno · različica {version}',
        publish_failed:   'Objava ni uspela.',
        saved:            'Shranjeno',
        saving:           'Shranjujem …',
        unsaved:          'Neshranjene spremembe',
        save_failed:      'Shranjevanje ni uspelo.',
        unpublished:      'Neobjavljene spremembe',
        load_failed:      'Postavitve ni bilo mogoče naložiti.',
        leave_title:      'Neshranjene spremembe',
        leave_message:    'Zadnjih sprememb ni bilo mogoče shraniti. Res želite zapustiti urejevalnik?',
        leave_confirm:    'Zapusti',
        close_preview:    'Zapri predogled (Esc)',

        add_element:      'Dodaj element',
        add_hint:         'Povlecite na zaslon',

        screen_format:    'Zaslon {ratio} ({w} × {h})',
        zoom_in:          'Povečaj',
        zoom_out:         'Pomanjšaj',
        zoom_fit:         'Prilagodi oknu',

        layers:           'Plasti',
        layers_hint:      '(od zgoraj navzdol)',
        layers_empty:     'Na zaslonu še ni elementov.',
        hide:             'Skrij',
        show:             'Prikaži',
        lock:             'Zakleni',
        unlock:           'Odkleni',
        drag_layer:       'Povlecite za spremembo vrstnega reda',
        rename_hint:      'Dvakrat kliknite za preimenovanje',

        properties:       'Lastnosti',
        tab_element:      'Element',
        tab_style:        'Slog',
        no_selection:     'Izberite element na zaslonu ali ga dodajte iz levega stolpca.',
        locked_hint:      'Element je zaklenjen — ne premika se.',
        delete:           'Izbriši',
        duplicate:        'Podvoji',
        bring_forward:    'Naprej',
        send_backward:    'Nazaj',

        text:             'Besedilo',
        font:             'Pisava',
        size:             'Velikost',
        weight:           'Teža pisave',
        color:            'Barva',
        background:       'Ozadje',
        radius:           'Robovi',
        alignment:        'Poravnava',
        position:         'Položaj in velikost',
        width_short:      'Š',
        height_short:     'V',
        rotation:         'Vrtenje',
        opacity:          'Prekrivnost',
        letter_spacing:   'Razmik črk',
        uppercase:        'Velike črke',
        padding:          'Notranji odmik',
        media:            'Datoteka',
        choose_media:     'Izberi iz Vsebin',
        replace_media:    'Zamenjaj',
        fit_label:        'Prikaz',
        muted:            'Brez zvoka',
        loop:             'Ponavljaj',
        show_description: 'Prikaži opis vremena',
        own_location:     'Lastna lokacija',
        own_location_hint: 'Sicer vreme za lokacijo zaslona.',
        location_label:   'Kraj',
        latitude:         'Zemljepisna širina',
        longitude:        'Zemljepisna dolžina',
        clock_format:     'Oblika',
        with_seconds:     'S sekundami',
        without_seconds:  'Brez sekund',
        show_date:        'Prikaži datum',
        qr_url:           'Povezava',
        qr_too_long:      'Povezava je predolga za QR kodo.',
        qr_fg:            'Barva kode',
        qr_bg:            'Ozadje kode',

        transparent:      'Prosojno',
        brand_color:      'Barva znamke {n}',
        custom_color:     'Barva po meri',
        apply:            'Uporabi',
        white:            'Bela',
        black:            'Črna',

        canvas_background: 'Ozadje zaslona',
        background_image:  'Slika ozadja',
        remove_image:      'Odstrani sliko',
        brand_actions:     'Znamka',
        brand_actions_hint: 'Hitro uskladite postavitev s celostno podobo.',
        apply_brand_font:  'Pisava znamke za vse besedilo',
        apply_brand_colors: 'Barve znamke',

        media_title:      'Izberite iz Vsebin',
        media_empty:      'V Vsebinah še ni datotek te vrste. Najprej jih naložite.',
        media_failed:     'Vsebin ni bilo mogoče naložiti.',

        new_text:         'Novo besedilo',

        image_source:      'Vir slike',
        source_file:       'Datoteka',
        source_brand_logo: 'Logotip znamke',
        source_guest_logo: 'Logotip gosta',
        role_brand_hint:   'Logotip videza, v katerem je zaslon. Če videz nima logotipa, je element na zaslonu skrit.',
        role_brand_none:   'Ta videz nima logotipa — dodajte ga pod Znamka.',
        role_guest_hint:   'Med sestankom logotip gosta. Brez sestanka ali brez logotipa gosta je element na zaslonu skrit.',
        brand_font:        'Pisava znamke ({font})',
        brand_font_hint:   'Sledi videzu zaslona.',
        guest_hint:        "{'{gost}'} se med sestankom zamenja z imenom gosta.",
        guest_token:       "{'{gost}'}",
        insert_guest:      "Vstavi {'{gost}'}",
        preview_look:      'Predogled videza',
        default_look:      'Osnovni videz',
    },

    menu: {
        placeholder:            'Meni — povežite blagajno Imprion POS',
        empty:                  'V izbranih kategorijah ni artiklov.',
        no_price_list:          'Happy hour — izbranega cenika v blagajni ni več',
        not_synced:             'Meni iz blagajne še ni uvožen. Povežite blagajno Imprion POS v nastavitvah.',
        title:                  'Naslov',
        title_hint:             'Prazno = brez naslova.',
        source:                 'Vir',
        source_categories:      'Kategorije',
        source_products:        'Izbrani artikli',
        categories:             'Kategorije',
        categories_hint:        'Brez izbire so prikazane vse kategorije v vrstnem redu menija.',
        categories_placeholder: 'Izberite kategorije',
        products:               'Artikli',
        products_hint:          'Prikazani so natanko ti artikli, v tem vrstnem redu.',
        products_placeholder:   'Poiščite artikle',
        search:                 'Iskanje …',
        product_count:          'Artiklov: {n}',
        missing_item:           'Ni več v blagajni',
        hidden_item:            'Skrito',
        move_up:                'Višje',
        move_down:              'Nižje',
        remove:                 'Odstrani',
        columns:                'Stolpci',
        max_items:              'Največ artiklov',
        show_prices:            'Cene',
        show_images:            'Slike',
        show_descriptions:      'Opisi',
        show_tags:              'Oznake',
        image_size:             'Velikost slike',
        image_position:         'Položaj',
        image_position_left:    'Levo',
        image_position_right:   'Desno',
        image_position_top:     'Zgoraj',
        image_shape:            'Oblika',
        image_shape_square:     'Kvadrat',
        image_shape_rounded:    'Zaobljeno',
        image_shape_circle:     'Krog',
        happy_hour:             'Happy hour cene',
        happy_hour_hint:        'Ko velja cenik iz blagajne, pokaže njegovo ceno in prečrta redno.',
        accent:                 'Poudarek',
        price_list:             'Cenik',
        any_list:               'Katerikoli aktiven cenik',
        any_list_hint:          'Vsak cenik razen osnovnega, ko velja.',
        list_off:               'izklopljen',
        active_now:             'zdaj velja',
        missing_list:           'Cenika ni več v blagajni',
        every_day:              'Vsak dan',
        whole_day:              'ves dan',
        weekdays: {
            1: 'pon',
            2: 'tor',
            3: 'sre',
            4: 'čet',
            5: 'pet',
            6: 'sob',
            7: 'ned',
        },
        text_active:            'Besedilo med happy hour',
        text_upcoming:          'Besedilo pred začetkom (danes)',
        placeholders_help:      "{'{from}'}, {'{to}'} in {'{name}'} se zamenjajo z uro začetka, uro konca in imenom cenika.",
        upcoming_help:          'Prazno = element je skrit, dokler happy hour ne velja.',
        show_products:          'Prikaži artikle s happy hour ceno',
    },

    playlist: {
        page:               'Stran {n} / {count}',
        previous:           'Prejšnja stran',
        next:               'Naslednja stran',
        play:               'Predvajaj',
        pause:              'Ustavi',
        time_hint:          '{s} s od {total} s te strani',
        none_playable:      'Nobena stran tega zaporedja ni objavljena',
        none_playable_hint: 'Zaslon predvaja samo objavljene postavitve. Objavite vsaj eno v urejevalniku.',
    },

    player: {
        product:        'Imprion DS',
        pair_title:     'Seznanite ta zaslon',
        pair_network:   'Odprite konzolo {product} na istem omrežju — zaslon se bo pojavil pod Zasloni.',
        pair_network_or_code: 'Ali vpišite kodo.',
        pair_pending:   'Čaka na potrditev v prostoru {tenant}',
        pair_pending_or_code: 'ali vpišite kodo v konzoli',
        pair_expires:   'Koda velja do {time}',
        pair_waiting:   'Pridobivam kodo …',
        pair_offline:   'Ni povezave s strežnikom. Poskušam znova …',
        loading:        'Nalagam vsebino …',
        offline:        'Brez povezave — predvajam shranjeno vsebino',
        fullscreen_hint: 'Kliknite kjerkoli za celozaslonski način',
    },
}

export type DesignMessages = typeof sl

export default sl
